module.exports = "<div class=\"account-box\">\r\n\t<div class=\"account-details hidden\">\r\n\t\t<div class=\"user-image\"></div>\r\n\t\t<p class=\"user-display-name\"></p>\r\n\t\t<button class=\"btn btn-primary sign-out\">Sign Out</button>\r\n\t</div>\r\n\t<div id=\"firebaseui-auth-container\"></div>\r\n\t<div class=\"clearfix\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/account-box/account-box.tpl.html
// module id = 38
// module chunks = 0